<!-- 中间title -->
<template>
    <div class='bg box box_between'>
        <div class="numberbg box_f1">
            <div class="title title1">首席服务员</div>
            <div class="subtitle subtitle1" v-if="userCount">{{userCount}}<span style="font-size:13px">人</span></div>
        </div>
        <div class="numberbg box_f1">
            <div class="title title2">收集问题</div>
            <div class="subtitle subtitle2" v-if="collectCount">{{collectCount}}<span style="font-size:13px">个</span></div>
        </div>
        <div class="numberbg box_f1">
            <div class="title title3">解决问题</div>
            <div class="subtitle subtitle3"  v-if="resolveCount">{{resolveCount}}<span style="font-size:13px">个</span></div>
        </div>
        <div class="numberbg box_f1">
            <div class="title title4">服务企业</div>
            <div class="subtitle subtitle4" v-if="companyCount">{{companyCount}}<span style="font-size:13px">个</span></div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            userCount:0,
            collectCount:0,
            resolveCount:0,
            companyCount:0,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.totalCount).then(res=>{
                //meetingCount
                this.userCount = res.rows[0].userCount.toLocaleString()
                this.collectCount = res.rows[0].collectCount.toLocaleString()
                this.resolveCount = res.rows[0].resolveCount.toLocaleString()
                this.companyCount = res.rows[0].companyCount.toLocaleString()

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/estate/middle1.png');
    background-size: 100% 100%;
    height:120px;
    align-items: center;
    padding:0 10px;
}
.numberbg{
    margin:0 10px;
    width:100%;
    height:88px;
    background-image: url('../../../../assets/images/monitorpy/numberbg.png');
    background-size: 100% 100%;
    
}
.title{
    font-size: 16px;
    line-height: 45px;
    text-align: center;
}
.title1{
    color:#7AA3FF
}
.title2{
    color:#01C3FF
}
.title3{
    color:#00EFE1
}
.title4{
    color:#F18B40
}
.subtitle{
    font-size: 26px;
    font-style: italic;
    color: #09D4FF;
    text-align: center;
}
.subtitle1{
    background: linear-gradient(180deg, #6693FF 0%, #C499FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.subtitle2{
    background: linear-gradient(180deg, #00F6FF 0%, #0290FE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.subtitle3{
    background: linear-gradient(180deg, #00FFCC 0%, #00EAFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.subtitle4{
    background: linear-gradient(180deg, #00F6FF 0%, #F18B40 0%, #D56400 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
        
</style>